/**
 * @fileoverview API for managing booking requests (for staff)
 */

import http from './http';

const ENDPOINTS = {
  BOOKING_REQUESTS: '/api/v1/booking-requests',
  BOOKING_REQUEST_BY_ID: (id) => `/api/v1/booking-requests/${id}`,
};

/**
 * Booking Requests API Service
 */
export const bookingRequestAPI = {
  /**
   * Get all booking requests with optional filters
   */
  list: async (params = {}) => {
    try {
      const response = await http.get(ENDPOINTS.BOOKING_REQUESTS, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching booking requests:', error);
      return {
        success: false,
        data: [],
        message: error.response?.data?.message || 'Failed to fetch booking requests'
      };
    }
  },

  /**
   * Get a single booking request by ID
   */
  getById: async (id) => {
    try {
      const response = await http.get(ENDPOINTS.BOOKING_REQUEST_BY_ID(id));
      return response.data;
    } catch (error) {
      console.error('Error fetching booking request:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch booking request'
      };
    }
  },

  /**
   * Update booking request status
   */
  updateStatus: async (id, status, notes = '') => {
    try {
      const response = await http.patch(ENDPOINTS.BOOKING_REQUEST_BY_ID(id), {
        status,
        notes
      });
      return response.data;
    } catch (error) {
      console.error('Error updating booking request:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to update booking request'
      };
    }
  },

  /**
   * Convert booking request to appointment
   */
  convertToAppointment: async (id, appointmentData) => {
    try {
      const response = await http.post(`${ENDPOINTS.BOOKING_REQUEST_BY_ID(id)}/convert`, appointmentData);
      return response.data;
    } catch (error) {
      console.error('Error converting booking request:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to convert booking request'
      };
    }
  }
};

export default bookingRequestAPI;
